import { Component } from '@angular/core';

@Component({
    selector: 'ngx-one-column-layout',
    styleUrls: ['./one-column.layout.scss'],
    template: `<nb-layout >
    <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

  <nb-layout-column>
    <ng-content select="router-outlet"></ng-content>
  </nb-layout-column>

  <nb-layout-footer class='footerMain'><ngx-footer></ngx-footer></nb-layout-footer>
</nb-layout>`
})

export class OneColumnLayout {
}